import * as React from 'react';
import { Layer, Text } from 'react-konva';
import { PIXEL_TO_CM_FACTOR, DOCUMENT_DATA_DPI } from '../../_config/Consts';
import { DocumentUnitTypes } from '../../Document/_stores/DocumentStore';

export type Props = {
	enabled: boolean
	viewerWidth?: number
	viewerHeight?: number
	documentOffsetX?: number
	documentOffsetY?: number
	documentWidth?: number
	documentHeight?: number
	documentDPI?: number
	documentUnits?: DocumentUnitTypes
}

enum Direction {
	Horizontal,
	Vertical
}

export default class Rulers extends React.Component<Props> {
	private textColor: string = "#333333";
	private rulerSize: number = 48;
	private fontSize: number = 14;

	private getNumberPlacement(i:number, dir:Direction, step:number, space:number, offset:number){
		let x, y, width, height;

		switch(dir){
			case Direction.Horizontal:
				x      = this.rulerSize + i * space + offset - (space * step) / 2;
				y      = this.props.viewerHeight - this.rulerSize + (this.fontSize / 2);
				width  = space * step;
				height = this.rulerSize;
			break;
			case Direction.Vertical:
				x      = - this.fontSize / 2;
				y      = i * space + offset - (this.fontSize / 2);
				width  = this.rulerSize;
				height = this.fontSize;
			break;
		}

		return [x, y, width, height];
	}

	private getNumbers(dir:Direction, step:number, space:number, offset:number, limit:number) {
		if(dir == Direction.Horizontal) offset -= this.rulerSize;
		let rulerOffsetLine = offset >= 0 ?  Math.floor(offset / space) : Math.ceil(offset / space);
		let rulerOffset = (offset / space - rulerOffsetLine) * space;

		let x, y, width, height;

		let stepOffset = rulerOffsetLine % step;

		let numbers = [];
		for (var i = stepOffset; i < limit; i += step) {
			[x, y, width, height] = this.getNumberPlacement(i, dir, step, space, rulerOffset);

			let size = this.fontSize;

			if (i.toString().length > 3) {
				size = 10;
			}

			numbers.push(<Text 
				key={i + '-text'}
				listening={false}
				fill={this.textColor}
				text={String(i + 1)}
				fontSize={size}
				align={dir == Direction.Horizontal ? "center" : "right"}
				x={x}
				y={y}
				width={width}
				height={height}
			/>);
		}
		return numbers;
	}

	private getHorizontalNumbers(space: number, step: number) {
		return this.getNumbers(
			Direction.Horizontal,
			step,
			space,
			this.props.documentOffsetX,
			(this.props.viewerWidth - this.rulerSize) / space,
		);
	}

	private getVerticalNumbers(space: number, step: number) {
		return this.getNumbers(
			Direction.Vertical,
			step,
			space,
			this.props.documentOffsetY,
			(this.props.viewerHeight - this.rulerSize) / space,
		);
	}

	private getSpace(){
		switch(this.props.documentUnits) {
			case DocumentUnitTypes.Pixels:
				return (this.props.documentDPI / DOCUMENT_DATA_DPI);
			break;
			case DocumentUnitTypes.Inches:
				return this.props.documentDPI;
			break;
			case DocumentUnitTypes.Centimeters:
				return (this.props.documentDPI / PIXEL_TO_CM_FACTOR);
			break;
		}
	}

	private getStep(){
		let space = this.getSpace();
		

		switch(this.props.documentUnits) {
			case DocumentUnitTypes.Pixels:
				if(this.props.documentDPI / 10 > 6) {
					return 100;
				} else if(this.props.documentDPI / 4 > 6) {
					return 500;
				} else if(this.props.documentDPI / 2 > 6) {
					return 1000;
				} else if(this.props.documentDPI / 0.8 > 6) {
					return 2500;
				} else if(this.props.documentDPI / 0.4 > 6) {
					return 5000;
				} else {
					return 10000;
				}
			break;
			case DocumentUnitTypes.Inches:
				if(this.props.documentDPI / 2 / 2 > 6) {
					return Math.ceil(2 / space);
				} else if(this.props.documentDPI / 2 > 6) {
					return 5;
				} else if(this.props.documentDPI / 0.2 / 4 > 6) {
					return 10;
				} else if(this.props.documentDPI / 0.1 / 4 > 6) {
					return 20;
				} else {
					return 40;
				}
			break;
			case DocumentUnitTypes.Centimeters:
				if(this.props.documentDPI / 2 / 2 > 6) {
					return 5;
				} else if(this.props.documentDPI / 2 > 6) {
					return 10;
				} else if(this.props.documentDPI / 0.2 / 4 > 6) {
					return 25;
				} else if(this.props.documentDPI / 0.1 / 4 > 6) {
					return 50;
				} else {
					return 100;
				}
			break;
		}
	}

	render = () => { 
		let space = this.getSpace();
		let step = this.getStep();

		return this.props.enabled && 
		<Layer listening={false} x={0} y={0}>
			{this.getHorizontalNumbers(space, step)}
			{this.getVerticalNumbers(space, step)}
		</Layer>
	}
}